import { Injectable } from '@angular/core';
import { DaysPlanner } from '../mocks/day-planner.mock';
import { of } from 'rxjs/internal/observable/of';
import { DaysPlane } from '../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DaysPlannerService {

  constructor() { }

  getDayPlanner(daysPlannerId): Observable<any> {
    return of(DaysPlanner);
  }
}
